// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22.7539 22.5H0.237305L11.4961 3L22.7539 22.5ZM11.4961 19V20.5H19.29L18.4238 19H11.4961ZM11.4961 17H17.2695L16.4033 15.5H11.4961V17ZM11.4961 13.5H15.249L14.3828 12H11.4961V13.5ZM11.4961 10H13.2285L11.4961 7V10Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M20.5322 3.4668L23.5693 4.75L20.5322 6.03223L19.25 9.06934L17.9668 6.03223L14.9307 4.75L17.9668 3.4668L19.25 0.430664L20.5322 3.4668Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-ai-coordinate-system-filled')
export default class AiCoordinateSystemFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai-coordinate-system-filled',
    }
  }
}
